/**
 * SYS-B-03 / V06-SYSCOHADA-05 (Phase 4 C4) — Équilibre d’une pièce avant enregistrement.
 * Valable pour toute pièce, y compris les écritures de paie (schéma unique : `EcrituresPaieGenerator`).
 */
import { roundFCFA } from '@shared/utils/round';

export type LigneEquilibre = { compte?: string; debit: number; credit: number };

export class PieceDesequilibreeError extends Error {
  constructor(public readonly debit: number, public readonly credit: number) {
    super(`Écriture non équilibrée : débit ${debit} ≠ crédit ${credit}`);
    this.name = 'PieceDesequilibreeError';
  }
}

export function totauxPiece(lignes: readonly LigneEquilibre[]): { debit: number; credit: number } {
  return {
    debit: roundFCFA(lignes.reduce((s, l) => s + (Number.isFinite(l.debit) ? l.debit : 0), 0)),
    credit: roundFCFA(lignes.reduce((s, l) => s + (Number.isFinite(l.credit) ? l.credit : 0), 0)),
  };
}

export function estPieceEquilibree(lignes: readonly LigneEquilibre[], tolerance = 0): boolean {
  const { debit, credit } = totauxPiece(lignes);
  return Math.abs(debit - credit) <= tolerance;
}

export function assertPieceEquilibree(lignes: readonly LigneEquilibre[]): void {
  const { debit, credit } = totauxPiece(lignes);
  if (debit !== credit) throw new PieceDesequilibreeError(debit, credit);
  if (debit <= 0) throw new Error('Écriture à montant nul refusée.');
}
